// Function to check if any sub-option is true
function checkIfAnyOptionTrue(subObject) {
  // Iterate through the subObject and check if any value is true
  return Object.values(subObject).includes(true);
}

// Function to check permissions dynamically
function checkPermission(permissions, permissionKey) {
  const permission = permissions?.[permissionKey];
  if (permission) {
    return checkIfAnyOptionTrue(permission);
  }
  return false;
}

export function checkPermissionByRoles(user, key) {
  const role = user?.user?.role;
  // console.log(user, "===checkPermissionByRoles")

  if (role === "teamMember") {
    let permissions = user.user.permission;
    // Ensure permissions is a valid object before using hasOwnProperty
    if (
      permissions &&
      typeof permissions === "object" &&
      permissions.hasOwnProperty(key)
    ) {
      const hasPermission = checkPermission(permissions, key);
      return hasPermission;
    }
  }
  return true;
}
